import { PollComponent } from '../poll/poll.component';
import { JobReportContractComponent } from '../job-report-contract/job-report-contract.component';
import { PerformAnswerDialogComponent } from '../perform-answer-dialog/perform-answer-dialog.component';
import { InvitePerformService } from '../../services/inviteperform.service';
import { PerformService } from '../../services/perform.service';
import { PerformComponent } from '../perform/perform.component';
import { PollListDialogComponent } from '../poll-list-dialog/poll-list-dialog.component';
import { PollSelectorDialogComponent } from '../poll-selector-dialog/poll-selector-dialog.component';
import { KanbanOfferContractStore } from '../state/kanban-offer-contract.store';
import { Component, OnInit, OnChanges, SimpleChanges, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpAuth } from '../../services/http-auth.service';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { KanbanOfferStore } from '../state/kanban-offer.store';
import { MdDialog } from '@angular/material';
import { ViewCvComponent } from '../view-cv/view-cv.component';
import { InviteService } from '../../services/invite.service';
import { ItemCandidateInviteComponent } from '../item-candidate-invite/item-candidate-invite.component';
import { KanbanComponent } from '../kanban/kanban.component';
import { CandidateService } from '../../services/candidate.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { InviteComponent } from '../invite/invite.component';
import { Constants } from '../constants';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-view-job-contract',
  templateUrl: './view-job-contract.component.html',
  styleUrls: ['./view-job-contract.component.css']
})
export class ViewJobContractComponent implements OnInit {

  check_mandatory: boolean;

  TYPE_QUESTION_SN = 1;
  TYPE_QUESTION_TEXT = 2;
  TYPE_QUESTION_NUMBER = 3;

  jobId: string;
  job: JobsOffer;
  viewinvite: boolean;
  invitations: any;

  selectedOption: any;

  perform: any;
  performInvitations: any;
  performLoading = true;
  performMax = 5;
  performPage = 1;
  performTotal: number;

  applyStatusList: any;
  users: any;
  usersFormReq: any;
  usersNotFormReq: any;

  usersReq: any;
  usersNotReq: any;

  checkMandatoryReq: boolean;
  checkMandatoryformReq: boolean;

  errorMessage: string;

  listPending: any;

  initialized: boolean;
  maxCandidates = 10000;

  invite: boolean;

  loading_job: boolean;

  public STATUS = Constants;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,

    @Inject(KanbanOfferContractStore) public KanbanOfferContractStore,
    private dialog: MdDialog,
    private _router: Router,
    private candidateService: CandidateService,
    private applyStatusService: ApplyStatusService,
    private performService: PerformService,
    private invitePerformService: InvitePerformService
  ) { }

  ngOnInit() {
    // TODO: get users invite to jobId

    this.loading_job = true;
    this.invite = true;
    this.KanbanOfferContractStore.restore();
    this.check_mandatory = true;
    this.checkMandatoryReq = true;
    this.checkMandatoryformReq = true;
    this.usersReq = [];
    this.usersNotReq = [];
    this.usersFormReq = [];
    this.usersNotFormReq = [];
    this.KanbanOfferContractStore.list = [];

    this.applyStatusService.getApplyStatus().subscribe(
        data => {
          this.applyStatusList = data;
          this.route.params.subscribe(params => {
            this.jobId = params['jobId'];
            if (typeof this.jobId !== 'undefined') {
              this.viewinvite = true;
              this.jobService.getOffersContractById(this.jobId).subscribe(
                data2 => {
                  this.job = data2;
                  this.loading_job = false;
                },
                error => {
                  this.errorMessage = <any>error;
                  this.loading_job = false;
                }
              );
              this.performService.getPerformByJob(this.jobId).subscribe(
                data3 => {
                  this.perform = data3.performs[0];
                  this.invitePerformService.getPerformInvites(this.jobId, this.performPage, this.performMax).subscribe(
                    res => {
                      this.performTotal = res.pagination.total;
                      this.performInvitations = res.performsinvitations;
                      this.performLoading = false;
                    },
                    error => {
                      this.errorMessage = <any>error;
                      this.performLoading = false;
                    }
                  );
                  console.log(this.perform);
                },
                error => {
                  this.errorMessage = <any>error;
                }
              );
              this.loadList();
              this.initialized = true;
            }
          });
          this.jobService.event.subscribe((data: JobsOffer) => {
            this.loadList();

          });
        },
        error => {
          this.errorMessage = <any>error;
        }
      );


  }

  loadList() {

    this.KanbanOfferContractStore.list = [];

    // Request Rejected
    let status = {
      applied: false,
      rejected: true,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: false,
      rehired: false,
      configurable: false,

    };

    // Rejected
    let kanban = new KanbanOfferContractStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Rechazados");
    kanban.statusID(-1);
    kanban.statusCustom(false);
    this.KanbanOfferContractStore.list.push(kanban);

    // Request Hired
     status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: true,
      rehired: false,
      configurable: false,
    };

    // Hired
    kanban = new KanbanOfferContractStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Seleccionados");
    kanban.statusID(300);
    kanban.statusCustom(false);
    this.KanbanOfferContractStore.list.push(kanban);

    // Request re Hired
     status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: false,
      rehired: true,
      configurable: false,
    };

    kanban = new KanbanOfferContractStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Contratados");
    kanban.statusID(375);
    kanban.statusCustom(false);
    this.KanbanOfferContractStore.list.push(kanban);

    // this.offerStoreHired.changeFilters(status, 1, this.maxCandidates, this.jobId);
  }

  openDialogDelete(job, status) {
      const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer = true;
      dialogRef.componentInstance.OfferID = job.id;
      dialogRef.componentInstance.OfferStatus = status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  openPerformList(perform, job) {
    const dialogRef = this.dialog.open(PerformComponent, {data: {

    }});

      dialogRef.afterClosed().subscribe(result => {
      });
      dialogRef.componentInstance.nameComponent = 'Modificar';
      dialogRef.componentInstance.PerformID = perform.id;
      dialogRef.componentInstance.perform = perform;
      dialogRef.componentInstance.Job = job;
    // this._router.navigate(['/pages/poll']);
  }

  openDialogPerform (name, id, job) {
    let dialogRef = this.dialog.open(PerformComponent);
        dialogRef.afterClosed().subscribe(result => {
    });
    dialogRef.componentInstance.nameComponent = name;
    dialogRef.componentInstance.PerformID = id;
    dialogRef.componentInstance.Performs = [];
    dialogRef.componentInstance.Job = job;
  }

  openDialogPoll(job) {
    const dialogRef = this.dialog.open(PollSelectorDialogComponent);
    dialogRef.componentInstance.JobID = job.id;
      dialogRef.afterClosed().subscribe(result => {
      });
    // this._router.navigate(['/pages/poll']);
  }

  openPollList(job) {
    const dialogRef = this.dialog.open(PollListDialogComponent, {data: {
      page: 1,
      pollMax: 6,
      job_id: job.id,
    }});

      dialogRef.afterClosed().subscribe(result => {
      });
    // this._router.navigate(['/pages/poll']);
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {},
        error => this.errorMessage = <any>error
      );
  }

  goToPerform(perform, type) {
    // const dialogRef = this.dialog.open(PerformAnswerDialogComponent, {data: {
    //   performInvite: perform,

    // }});
    // dialogRef.afterClosed().subscribe(result => {});

    const dialogRef = this.dialog.open(JobReportContractComponent, {
      data: {
        job: this.job,
        create: type,
        users: perform.users,
        perform: perform.perform,
        perform_date: perform.created_at,
        report_data: perform.report_data,
        report_users: perform.report_users
      }});
    dialogRef.afterClosed().subscribe(result => {
      this.fetchPerforms(this.performPage);
    });
  }

  fetchPerforms(id) {
    this.performPage = id;
    this.invitePerformService.getPerformInvites(this.jobId, this.performPage, this.performMax).subscribe(
      res => {
        this.performTotal = res.pagination.total;
        this.performInvitations = res.performsinvitations;
        this.performLoading = false;
      },
      error => {
        this.errorMessage = <any>error;
        this.performLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-job-contract/view-job-contract.component.ts